/**
 * Lightweight toast notification replacement for toastr.
 * Uses Bootstrap 5 toast markup — no jQuery dependency.
 * API matches toastr: success(msg, title?), warning(msg, title?), error(msg, title?).
 */

let container: HTMLElement | null = null;

function ensureContainer(): HTMLElement {
  if (!container || !document.body.contains(container)) {
    container = document.createElement('div');
    container.className = 'toast-container position-fixed top-0 end-0 p-3';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
  }
  return container;
}

const bgClasses: Record<string, string> = {
  success: 'text-bg-success',
  warning: 'text-bg-warning',
  error: 'text-bg-danger',
  info: 'text-bg-info',
};

interface ToastrOptions {
  closeButton?: boolean;
  timeOut?: number;
  extendedTimeOut?: number;
  positionClass?: string;
}

function showToast(type: string, message: string, title?: string): void {
  const c = ensureContainer();
  const toastEl = document.createElement('div');
  toastEl.className = `toast align-items-center border-0 ${bgClasses[type] ?? 'text-bg-info'}`;
  toastEl.setAttribute('role', 'alert');
  toastEl.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">
        ${title ? `<strong>${title}</strong> ` : ''}${message}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"></button>
    </div>`;
  c.appendChild(toastEl);

  // Use Bootstrap 5 Toast API if available, otherwise just show/hide manually
  const bsToast = (window as any).bootstrap?.Toast;
  if (bsToast) {
    new bsToast(toastEl, { delay: 5000 }).show();
  } else {
    toastEl.classList.add('show');
    setTimeout(() => { toastEl.remove(); }, 5000);
  }
  toastEl.addEventListener('hidden.bs.toast', () => toastEl.remove());
}

export const ppToastr = {
  options: {} as ToastrOptions,
  success(message: string, title?: string) { showToast('success', message, title); },
  warning(message: string, title?: string) { showToast('warning', message, title); },
  error(message: string, title?: string) { showToast('error', message, title); },
  info(message: string, title?: string) { showToast('info', message, title); },
};
